module.exports = __webpack_public_path__ + "img/25a83f9964e2849042375bda4c9c141e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo16.png
// module id = 924
// module chunks = 5